// extracted by mini-css-extract-plugin
export default {"loaderContainer":"table_loaderContainer__F2hCg","loaderBackdrop":"table_loaderBackdrop__sy+qE","loader":"table_loader__L6W9u"};